import { CommonLaboratoryResponse } from '@/api/services/common.dto'
import { StrictNullable } from '@/shared/types/app.types'
import { AccountingUnitResponse } from '@/api/services/billing/common-accounting-unit/billing-common-accounting-unit.dto'
import {
    accountingUnitResponseMock
} from '@/api/services/billing/common-accounting-unit/billing-common-accounting-unit.mock'

export interface ConfigurationLocalAccountingRatesCopyModalRate {
    name: string
    code: string
    laboratory: StrictNullable<CommonLaboratoryResponse>
    startDate: StrictNullable<Date>
    endDate: StrictNullable<Date>
    copyValues: boolean
    isDefault: boolean
    allowsCopayment: boolean
}

export interface ConfigurationLocalAccountingRatesCopyModalState {
    rateOriginalCopyName: string
    copyRate: ConfigurationLocalAccountingRatesCopyModalRate
    billableRateToBeCopiedId: number
    laboratoryId: StrictNullable<number>
    todayDate: Date
    finishDate: Date
    laboratories: CommonLaboratoryResponse[],
    unit: AccountingUnitResponse
}

export const initialLocalAccountingRatesCopyModalState =
    (): ConfigurationLocalAccountingRatesCopyModalState => {
        const today = new Date()
        const finishDate = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate())
        return {
            rateOriginalCopyName: '',
            copyRate: {
                name: '',
                code: '',
                laboratory: null,
                startDate: today,
                endDate: finishDate,
                copyValues: false,
                isDefault: false,
                allowsCopayment: false
            },
            laboratoryId: null,
            todayDate: today,
            finishDate: finishDate,
            laboratories: [],
            billableRateToBeCopiedId: -1,
            unit: accountingUnitResponseMock()
        }
    }
